import React from 'react';
import { Alert } from 'antd';
import './index.less';

export default class ErrorBoundary extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      errorInfo: null,
    };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error,
      errorInfo,
    });
  }

  render() {
    const { errorInfo, error } = this.state;
    const { children } = this.props;
    if (errorInfo) {
      const message = error && error.toString();
      const description = errorInfo.componentStack;
      return (
        <Alert
          style={{
            maxWidth: 700,
            margin: 'auto',
          }}
          message={message}
          description={description}
          type="error"
          closable
        />
      );
    }
    return children;
  }
}

ErrorBoundary.defaultProps = {
  children: [],
};
